import { useQuery } from 'react-query';

import { publicExportsApi } from 'src/Services/API';
import { EventDetailsDto } from 'src/Services/API/generated';

const useFetchExportedEvent = ({ token, eventId }: { token?: string; eventId?: string }) => {
  return useQuery({
    queryKey: ['fetch-exported-event', token, eventId],
    queryFn: async () => {
      if (!eventId) throw new Error('No eventId provided');
      if (!token) throw new Error('No token provided');

      return (await publicExportsApi.publicExportsControllerFindEntityById(token, eventId))
        .data as unknown as EventDetailsDto;
    },
    enabled: !!eventId && !!token,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchExportedEvent;
